import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'

import * as modalActions from '../../../../actions/modal'

import LookNamePanel from './index'

const AddToNewLookPanel = ({addLook}) => <LookNamePanel onLookClicked={addLook} />

AddToNewLookPanel.propTypes = {
  addLook: PropTypes.func.isRequired,
}

const mapDispatchToProps = {addLook: modalActions.addLookForSelectedLookName}

export default connect(null, mapDispatchToProps)(AddToNewLookPanel)
